import axios from "axios";
import router from "../router";
import { ROUTE_NAMES } from "@/constants/routeConstants";

const HTTP_UNAUTHORIZED = 401;
const HTTP_NOT_FOUND = 401;
const VALID_RESPONSES = [200, 201, 204];

const api = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  withCredentials: true,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

api.defaults.withCredentials = true;
api.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

api.interceptors.response.use(
  (response) => {
    if (VALID_RESPONSES.includes(response.status)) {
      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    }
  },
  (error) => {
    if (error.response.status) {
      switch (error.response.status) {
        case 400:
          //do s//omething
          break;

        case HTTP_UNAUTHORIZED:
          // alert("session expired");
          router.replace({
            name: ROUTE_NAMES.login,
            params: { locale: "et" },
          });
          break;
        case 403:
          // empty
          break;
        case HTTP_NOT_FOUND:
          alert("page not exist");
          break;
        case 502:
          setTimeout(() => {
            router.replace({
              name: ROUTE_NAMES.login,
              params: { locale: "et" },
            });
          }, 1000);
      }
      return Promise.reject(error.response);
    }
  }
);

api.params = (props) => {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(props)) {
    params.append(key, value);
  }
  return params;
};

export default api;
